import {Card, Paper, Typography} from "@mui/material";
import {COLORS} from "../../../ui/Theme";
import {useHistoryContext} from "../../../context/derivatives/history/HistoryContext";
import HistoryFormAutoComplete from "./HistoryFormAutoComplete";
import {useEffect} from "react";
import {HistoryHeaderName} from "../../../components/tableHeaderNames/HeaderName";
import Table from "../../../components/table/Table";
import Grid2 from "@mui/material/Unstable_Grid2";
import HistoryPriceChart from "./HistoryPriceChart";
import HistoryVolumeChart from "./HistoryVolumeChart";

const History = () => {

    const {
        assets,
        selectedAssetName,
        setSelectedAssetName,
        symbols,
        selectedSymbol,
        setSelectedSymbol,
        tableAndChartData,
        isLoading,
    } = useHistoryContext();

    useEffect(() => {
        if (!selectedAssetName) {
            setSelectedSymbol(null);
        }
    }, [selectedAssetName, setSelectedSymbol]);

    return (
        <Paper sx={{display: "flex", flexDirection: "column", gap: "14px"}}>
            <Typography
                sx={{
                    color: COLORS.BLACK,
                    fontSize: "16px",
                    fontWeight: 700,
                }}
            >
                تاریخچه
            </Typography>

            {/*form*/}
            <Card>
                <Grid2 container spacing={2}>
                    <Grid2 xs={12} md={6} lg={2}>
                        {/*assets*/}
                        <HistoryFormAutoComplete
                            options={assets?.data}
                            value={selectedAssetName}
                            setValue={setSelectedAssetName}
                            isDisable={assets?.isValidating}
                            placeholder="نام سهم را وارد کنید"
                            isLoading={assets?.isValidating}
                        />
                    </Grid2>
                    <Grid2 xs={12} md={6} lg={2}>
                        {/*symbols*/}
                        <HistoryFormAutoComplete
                            options={symbols}
                            value={selectedSymbol}
                            setValue={setSelectedSymbol}
                            isDisable={!selectedAssetName || isLoading.symbol}
                            placeholder="نام نماد را وارد کنید"
                            isLoading={isLoading.symbol}
                        />
                    </Grid2>
                </Grid2>
            </Card>

            {/*charts*/}
            <Grid2 container spacing={"20px"}>
                <Grid2 xs={12} lg={6}>
                    <HistoryPriceChart data={tableAndChartData}/>
                </Grid2>

                <Grid2 xs={12} lg={6}>
                    <HistoryVolumeChart data={tableAndChartData}/>
                </Grid2>
            </Grid2>

            {/*table*/}
            <Card>
                <Table
                    tableData={tableAndChartData}
                    faCols={HistoryHeaderName}
                    height="80vh"
                    tableTitle={{
                        title: "تاریخچه"
                    }}
                />
            </Card>
        </Paper>
    );
};

export default History;